/**
 * Conversation lead-draft — BUB-140 convert-to-lead prefill.
 */

import api from "../../../shared/api.jsx";

/**
 * Resolve n8n draft + OS duplicate guard for convert-to-lead.
 * @param {string} channelId
 * @param {{ customerName?: string }} [options]
 * @returns {Promise<Object>}
 */
export const getConversationLeadDraft = async (channelId, options = {}) => {
  const params = { channelId };
  if (options.customerName) {
    params.customerName = options.customerName;
  }

  const response = await api.get("/leads/conversations/lead-draft", { params });
  return response.data ?? response;
};
